import produce from "immer";
import { constants } from "./actions";
import { commonConstants } from "../common/actions";
import { paginationUtils } from "./utils";

const { REQUEST, SUCCESS, FAILURE } = commonConstants;
const {
  SUBMIT_BRIEFING_FORM,
  FETCH_BRIEFING_LIST,
  DELETE_BRIEFING,
  UPDATE_BRIEFING,
  RESET_BRIEFING_FORM_FIELDS,
  FETCH_BRIEFING,
  UPDATE_BRIEFING_FORM_FIELD,
  UPDATE_BRIEFING_SEARCH_QUERY,
  NEXT_BRIEFINGS_PAGE,
  PREV_BRIEFINGS_PAGE,
  LAST_BRIEFINGS_PAGE,
  FIRST_BRIEFINGS_PAGE,
} = constants;

const initState = {
  id: null,
  name: "",
  createdBy: "",
  date: null,
  updatedAt: null,
  notes: "",
  // async
  list: [],
  loading: {},
  error: {},
  success: {},
  searchQuery: "",
  pageOffset: 0,
  briefingsPerPage: 10,
  page: 1,
  totalBriefings: 0,
  totalPages: 1,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case UPDATE_BRIEFING_FORM_FIELD:
      return produce(state, (draft) => {
        draft[action.field] = action.value;
        draft.loading = {};
        draft.error = {};
        draft.success = {};
      });
    case UPDATE_BRIEFING_SEARCH_QUERY:
      return produce(state, (draft) => {
        draft.searchQuery = action.value;
        draft.loading = {};
        draft.error = {};
        draft.success = {};
      });
    case RESET_BRIEFING_FORM_FIELDS:
      const success = {
        source: RESET_BRIEFING_FORM_FIELDS,
        message: "All form fields were successfully reset.",
      };
      if (!action.payload.showMessage) {
        delete success.message;
      }
      state = {
        ...initState,
        success,
      };
      return state;
    case SUBMIT_BRIEFING_FORM + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: action.payload.source };
      });
    case SUBMIT_BRIEFING_FORM + SUCCESS:
      return produce(state, (draft) => {
        draft.success = {
          source: action.payload.source,
          message: action.payload.message,
        };
      });
    case SUBMIT_BRIEFING_FORM + FAILURE:
      return produce(state, (draft) => {
        draft.error = {
          source: action.payload.source,
          message: action.payload.message,
        };
      });
    case FETCH_BRIEFING_LIST + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: action.source };
      });
    case FETCH_BRIEFING_LIST + SUCCESS: {
      const { list, total, offset, limit } = action.payload;
      return produce(state, (draft) => {
        draft.success = action.payload;
        draft.loading = {};
        draft.totalBriefings = total;
        draft.totalPages = Math.ceil(total / limit);
        draft.pageOffset = offset;
        draft.briefingsPerPage = limit;
        draft.list = list;
      });
    }
    case FETCH_BRIEFING_LIST + FAILURE:
      return produce(state, (draft) => {
        draft.error = {
          source: action.payload.source,
          message: action.payload.message,
        };
        draft.loading = {};
      });
    case DELETE_BRIEFING + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: action.source };
      });
    case DELETE_BRIEFING + SUCCESS: {
      const { source, message, id } = action.payload;
      return produce(state, (draft) => {
        draft.success = { source, message };
        draft.list = state.list.filter((briefing) => briefing.id !== id);
        draft.loading = {};
      });
    }
    case DELETE_BRIEFING + FAILURE:
      return produce(state, (draft) => {
        draft.error = {
          source: action.payload.source,
          message: action.payload.message,
        };
        draft.loading = {};
      });
    case UPDATE_BRIEFING + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: UPDATE_BRIEFING };
      });
    case UPDATE_BRIEFING + SUCCESS:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.success = action.payload;
      });
    case UPDATE_BRIEFING + FAILURE:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.error = action.payload;
      });
    case FETCH_BRIEFING + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: FETCH_BRIEFING };
      });
    case FETCH_BRIEFING + SUCCESS:
      const { id, name, notes, date, createdBy, updatedAt } =
        action.payload.briefing;
      return produce(state, (draft) => {
        draft.loading = {};
        draft.success = action.payload;
        draft.id = id;
        draft.date = date;
        draft.updatedAt = updatedAt;
        draft.name = name;
        draft.createdBy = createdBy;
        draft.notes = notes;
      });
    case FETCH_BRIEFING + FAILURE:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.error = action.payload;
      });
    case NEXT_BRIEFINGS_PAGE: {
      const pagination = paginationUtils(state);
      const { nextPage, nextPageOffset } = pagination.toNextPage();
      return produce(state, (draft) => {
        draft.pageOffset = nextPageOffset;
        draft.page = nextPage;
      });
    }
    case PREV_BRIEFINGS_PAGE: {
      const pagination = paginationUtils(state);
      const { prevPage, prevPageOffset } = pagination.toPrevPage();
      return produce(state, (draft) => {
        draft.pageOffset = prevPageOffset;
        draft.page = prevPage;
      });
    }

    case LAST_BRIEFINGS_PAGE: {
      const pagination = paginationUtils(state);
      const { lastPageOffset, lastPage } = pagination.toLastPage();
      return produce(state, (draft) => {
        draft.pageOffset = lastPageOffset;
        draft.page = lastPage;
      });
    }

    case FIRST_BRIEFINGS_PAGE: {
      const pagination = paginationUtils(state);
      const { firstPageOffset, firstPage } = pagination.toFirstPage();
      return produce(state, (draft) => {
        draft.pageOffset = firstPageOffset;
        draft.page = firstPage;
      });
    }
    default:
      return state;
  }
}
